module.exports = {
	"de": {
		"title": "Neu",
		"button": {
			"buy": "Jetzt kaufen",
			"visit": "Jetzt besuchen"
		}
	},
	"en": {
		"title": "Featured",
		"button": {
			"buy": "Get It Now",
			"visit": "Visit Now"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/showcase/locales.json
// module id = 70
// module chunks = 0